import React, { useMemo, useState } from "react";
import { useQuery } from "@apollo/client";
import CommunicationModal from "./CommunicationModal";
import CommuniModal from "./CommuiModal";
import gqlPreAuth from "../../../gql/preAuth";

import "../styles/pre-auth.css";
import AppModal from "../../../components/AppModal";
import { MdAttachFile, MdDownload } from "react-icons/md";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";
import { LuReply } from "react-icons/lu";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TableLoader from "../../../common/TableLoader";
import AdvanceCommuniModal from "./AdvanceCommuniModal";
import AppButton from "../../../shared/AppButton";
import AppTable from "../../../shared/AppTable";

export const encodeCode = (code) => {
  if (!code) return null;

  if (/^[0-9-]+$/.test(code)) {
    return Number(code.replace(/-/g, ""));
  }

  return Number(
    code
      .split("")
      .map((ch) => ch.charCodeAt(0))
      .join(""),
  );
};

const AdvanceCommunicationDetail = ({ item, currentItem }) => {
  const { t, i18n } = useTranslation();
  const [showCommunicationModal, setshowCommunicationModal] = useState(false);
  const [communicationId, setCommunicationId] = useState("");
  const [dataArray, setdataArray] = useState([]);
  const { id } = useParams();
  const location = useLocation();
  const state = location?.state;
  const transactionId = state?.currentItem?.transaction_id;
  const {
    loading: communicationLoading,
    error: communicationError,
    data: communicationData,
    refetch: communicationRefetch,
  } = useQuery(gqlPreAuth.GET_TRANSACTION_COMMUNICATIONS, {
    variables: {
      input: {
        transaction_id: transactionId,
        // request_name: "preAuth",
        request_name: "advanced-auth",
      },
    },
    fetchPolicy: "network-only",
  });

  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  const findSequence = (seq) => {
    const findSeq = item?.find((i) => Number(i.sequence_no) === Number(seq));
    return findSeq
      ? `${findSeq.standard_description || findSeq.display || findSeq.code || seq}`
      : seq || "N/A";
  };
  const flattenedData = useMemo(() => {
    const rawData =
      communicationData?.listCommunicationsByTransactionId?.data || [];
    let temp = [];
    rawData.forEach((comm) => {
      comm.payload.forEach((pay) => {
        temp.push({
          ...pay, // Payload details
          parentComm: comm, // Parent communication details for Bundle ID, Date etc.
          id: comm.id, // Parent ID for reply
        });
      });
    });
    return temp;
  }, [communicationData]);
  const columns = [
    {
      header: t("Bundle Id"),
      render: (row) => (
        <span className="text-[10px]">{row.parentComm?.bundle_id}</span>
      ),
    },
    {
      header: t("Date"),
      render: (row) => (
        <span className="text-[10px]">
          {new Date(row.parentComm?.timestamp).toLocaleDateString("en-GB")}{" "}
          <br />
          {new Date(row.parentComm?.timestamp).toLocaleTimeString("en-GB")}
        </span>
      ),
    },
    {
      header: t("Type"),
      render: (row) => (
        <span className="text-[10px]">{row.parentComm?.type}</span>
      ),
    },
    {
      header: t("Comment/File"),
      render: (row) => {
        const attachment = row?.payload_attachment;
        const hasAttachment =
          attachment &&
          (attachment.payload_attachment_data ||
            attachment.payload_attachment_url);

        return (
          <div className="max-w-[220px] whitespace-normal">
            {/* Comment */}
            {row?.payload_comment && (
              <span className="text-[10px]">{row.payload_comment}</span>
            )}

            {/* Attachment */}
            {hasAttachment && (
              <div className="flex items-center gap-1 text-blue-600 mt-1">
                <MdAttachFile size={16} />

                <span className="text-[10px] truncate max-w-[150px]">
                  {attachment.payload_attachment_title || "File"}
                </span>

                <MdDownload
                  size={16}
                  className="cursor-pointer hover:text-blue-800"
                  onClick={() => {
                    if (attachment.payload_attachment_url) {
                      window.open(
                        attachment.payload_attachment_url,
                        "_blank",
                        "noopener,noreferrer",
                      );
                    } else {
                      downloadBase64File(
                        attachment.payload_attachment_data,
                        attachment.payload_attachment_title || "file",
                        attachment.payload_attachment_content_type ||
                          "application/octet-stream",
                      );
                    }
                  }}
                />
              </div>
            )}

            {/* Nothing */}
            {!row?.payload_comment && !hasAttachment && (
              <span className="text-[10px] text-gray-400">N/A</span>
            )}
          </div>
        );
      },
    },
    {
      header: t("Item Seq."),
      render: (row) => (
        <span className="text-[10px]">
          {row?.item_sequence ? findSequence(row.item_sequence) : "N/A"}
        </span>
      ),
    },
    {
      header: t("Reply"),
      render: (row) =>
        row.parentComm?.creator === "payer" ? (
          <Tooltip title="Reply">
            <button
              onClick={() => {
                setCommunicationId(row.id);
                setshowCommunicationModal(true);
              }}
              className="text-lg text-blue-600 hover:text-blue-800"
            >
              <LuReply />
            </button>
          </Tooltip>
        ) : null,
    },
  ];

  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true, // Skip initial fetching
  });

  const pollClicked = () => {
    toast.loading("Requesting!");
    refetchPoll().then(async (res) => {
      toast.success(res?.data?.pollRequest?.message || "Request Successfully!");
      await communicationRefetch({
        input: {
          transaction_id: currentItem?.transaction_id,
          request_name: "preAuth",
        },
      });
    });
  };
  return (
    <>
      {communicationLoading ? (
        <div className="mt-3">
          <TableLoader
            columns={5}
            showHeaderButtons={true}
            headerButtonsCount={1}
          />
        </div>
      ) : (
        <div class="pre_auth_communication_page ">
          <div class="add_communication !p-2  !bg-transparent !border-none !shadow-none">
            <div className="flex justify-end gap-2 mb-2">
              <AppButton
                label={t("Add Communication")}
                startIcon={<AddIcon />}
                onClick={() =>
                  setshowCommunicationModal(!showCommunicationModal)
                }
              />
            </div>

            <AppTable columns={columns} data={flattenedData} actions={false} />
          </div>
          <AdvanceCommuniModal
            dataArray={dataArray}
            item={item}
            Advance={true}
            transactionId={transactionId}
            currentItem={currentItem}
            setdataArray={setdataArray}
            showCommunicationModal={showCommunicationModal}
            setshowCommunicationModal={setshowCommunicationModal}
            communicationId={communicationId}
            communicationRefetch={communicationRefetch}
          />
        </div>
      )}
    </>
  );
};

export default AdvanceCommunicationDetail;
